module.exports = __webpack_public_path__ + "static/media/undraw_Online_cv_re_gn0a.7f994901.png";